module.exports = __webpack_public_path__ + "pn.svg?9de82ae3056dab1d58f79e36c0d4741a";